import React__default, { useState } from 'react';
import './NavRail.css.js';

function NavigationRail({ items, defaultActive, position = "left", expanded: defaultExpanded = false, onChange, footerItem, logo = "", }) {
    var _a;
    const [active, setActive] = useState(defaultActive || ((_a = items[0]) === null || _a === void 0 ? void 0 : _a.key));
    const [expanded, setExpanded] = useState(defaultExpanded);
    const handleSelect = (key) => {
        setActive(key);
        onChange === null || onChange === void 0 ? void 0 : onChange(key);
    };
    return (React__default.createElement("nav", { className: `nav-rail ${position} ${expanded ? "expanded" : "collapsed"}` },
        React__default.createElement("div", { className: "nav-rail-header" },
            React__default.createElement("span", { className: "nav-rail-logo" }, logo),
            React__default.createElement("button", { className: "nav-rail-toggle", onClick: () => setExpanded(!expanded), "aria-label": "Toggle navigation" }, expanded ? "«" : "»")),
        React__default.createElement("ul", { className: "nav-rail-list" }, items.map((item) => (React__default.createElement("li", { key: item.key, className: `nav-rail-item ${active === item.key ? "active" : ""}`, onClick: () => handleSelect(item.key) },
            React__default.createElement("span", { className: "nav-rail-icon" }, item.icon),
            React__default.createElement("span", { className: "nav-rail-label" }, item.label))))),
        footerItem && (React__default.createElement("div", { className: `nav-rail-footer ${active === footerItem.key ? "active" : ""}`, onClick: () => handleSelect(footerItem.key) },
            React__default.createElement("span", { className: "nav-rail-icon" }, footerItem.icon),
            expanded && React__default.createElement("span", { className: "nav-rail-label" }, footerItem.label)))));
}

export { NavigationRail };
//# sourceMappingURL=NavigationRail.js.map
